import React from 'react';
import classNames from 'classnames';

import withStyles from '@mui/styles/withStyles';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Datetime from 'components/Shared/Datetime';
import InfoSuiviColis from 'components/Shared/InfoSuiviColis';
import ColisLogistiquePhoto from 'components/Shared/ColisLogistiquePhoto';

import { Modeslivraison } from 'constants.js';

const styles = theme => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    listeColis: {
        padding: theme.spacing(2)
    },

    container: {
        display: 'flex',
        width: '100%'
    },

    containerLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        width: '100%'
    },

    containerRight: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minWidth: '35%'
    },

    expandHeader: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    },

    expandDetails: {
        flexDirection: 'column'
    },

    expandDetailsRoot: {
        marginTop: 0,
        paddingTop: 0
    },

    expandDetailsArticles: {
        marginTop: 10
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },

    anomalieExpandHeader: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: '4px 8px 4px 8px'
    },

    anomalie: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: '4px 8px 4px 8px'
    }
});

const anomalieExpeditionLabels = [
    "",
    "Pas de date d'expédition",
    "Plusieurs dates d'expédition",
    "Etat pas expédié",
    "Palette MONO",
    "Monne 1 et 2"
];

class InfosLogistique extends React.Component {

    handleClick = (event, actionName) => {
        event.preventDefault();
        this.props.onClick(actionName);
    };

    render() {
        const { classes, infosLogistique } = this.props;

        return (
            <React.Fragment>
                {infosLogistique && <>

                    {
                        infosLogistique.numeroPiece && (
                            <Paper className={classes.paper}>
                                <Typography variant="h6" gutterBottom>FMCP / GESCOM</Typography>

                                <div className={classes.container}>
                                    <div className={classes.containerLeft}>
                                        <Typography gutterBottom>Concerne la pièce <span className={classes.bold}>{infosLogistique.numeroPiece}</span>{infosLogistique.client && <> pour le client <span className={classes.bold}>{infosLogistique.client.code + " - " + infosLogistique.client.libelle}</span></>}</Typography>
                                        <Typography gutterBottom>Preneur de commande <span className={classes.bold}>{infosLogistique.preneurCommande}</span></Typography>
                                        <Typography gutterBottom>Mode de livraison commande : <span className={classes.bold}>{infosLogistique.modeLivraison}</span></Typography>
                                        <Typography gutterBottom>Dépôt de départ : <span className={classes.bold}>{infosLogistique.depotDepart ? `${infosLogistique.depotDepart.codeDepot} - ${infosLogistique.depotDepart.nom}` : ''}</span></Typography>
                                        <Typography gutterBottom>Service demandé : <span className={classes.bold}>{infosLogistique.serviceDemande}</span></Typography>
                                        <Typography gutterBottom>Contrat : <span className={classes.bold}>{infosLogistique.contrat}</span></Typography>
                                        { infosLogistique.depotDestination && (                                                
                                                <Typography gutterBottom>Dépôt destination : <span className={classes.bold}>{`${infosLogistique.depotDestination.codeDepot} - ${infosLogistique.depotDestination.nom}`}</span></Typography>
                                            )
                                        }
                                        <Typography gutterBottom>Date expédition demandé : <span className={classes.bold}><Datetime datetime={infosLogistique.dateExpedition} /></span></Typography>
                                        <Typography>Portable suivi colis commande : <span className={classes.bold}>{infosLogistique.suiviColisTelephoneMobile}</span></Typography>
                                    </div>

                                    <Paper className={classNames(classes.paper, classes.containerRight)} elevation={1}>
                                        <Typography variant="subtitle1" gutterBottom>Facturation</Typography>

                                        <Typography gutterBottom>{infosLogistique.facturationNom}</Typography>
                                        <Typography gutterBottom>{infosLogistique.facturationAdresse1}</Typography>
                                        <Typography gutterBottom>{infosLogistique.facturationAdresse2}</Typography>
                                        <Typography gutterBottom>{infosLogistique.facturationCodePostal} {infosLogistique.facturationVille}</Typography>

                                        {infosLogistique.reliquat &&
                                            <Typography gutterBottom><span className={classes.bold}>{infosLogistique.reliquat ? "Reliquat" : null}</span></Typography>
                                        }
                                    </Paper>
                                </div>
                            </Paper>
                        )
                    }

                    {
                        infosLogistique.numeroPreparation && (
                            <Paper className={classes.paper}>
                                <Typography variant="h6" gutterBottom>Morpheus / Logistique</Typography>

                                <div className={classes.container}>
                                    <div className={classes.containerLeft}>
                                        <Typography gutterBottom>Concerne la préparation <span className={classes.bold}>{infosLogistique.numeroPreparation}</span></Typography>
                                        <Typography gutterBottom>Descendu dans Morpheus le <span className={classes.bold}><Datetime withTime datetime={infosLogistique.dateDescenteLogistique} /></span></Typography>
                                        <Typography gutterBottom>Transporteur Morpheus : <span className={classes.bold}>{infosLogistique.transporteur} / {infosLogistique.contratTransporteur}</span></Typography>
                                        <Typography gutterBottom>Numéro enlèvement transporteur : <span className={classes.bold}>{infosLogistique.numeroEnlevementTransporteur}</span></Typography>
                                        <Typography gutterBottom>Code relais colis : <span className={classes.bold}>{infosLogistique.codeRelaisColis}</span></Typography>

                                        <InfoSuiviColis
                                            numeroPiece={infosLogistique.numeroPiece}
                                            afficheSuiviColisDetaille
                                        />
                                    </div>

                                    <Paper className={classNames(classes.paper, classes.containerRight)} elevation={1}>
                                    <Typography variant="subtitle1" gutterBottom>Livraison{infosLogistique.modeLivraison !== Modeslivraison.IMM ? '' : ` en magasin`}</Typography>

                                        <Typography gutterBottom>{infosLogistique.nomLivraison}</Typography>
                                        <Typography gutterBottom>{infosLogistique.livraisonAdresse1}</Typography>
                                        <Typography gutterBottom>{infosLogistique.livraisonAdresse2}</Typography>
                                        <Typography gutterBottom>{infosLogistique.livraisonCodePostal} {infosLogistique.livraisonVille}</Typography>
                                    </Paper>
                                </div>

                                {infosLogistique.colis && (
                                    <Paper className={classes.listeColis} elevation={1}>
                                        <Typography variant="subtitle1" gutterBottom>Liste des colis</Typography>

                                        {infosLogistique.colis.map((x, index) => (
                                            <Accordion elevation={1} key={x.id ? x.id : index}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{
                                                        "& .MuiAccordionSummary-content": {
                                                            alignItems: 'baseline',
                                                        }
                                                    }}
                                                >
                                                    <Typography className={x.anomalieExpedition ? classes.anomalieExpandHeader : classes.expandHeader}>
                                                        Colis {index + 1} : {x.numeroTracking} / {x.numeroSSCC} / {x.numeroSupport}{x.recepisse !== null ? ' / ' + x.recepisse : ''} / Poids théorique: {x.poidsTheorique} / Poids mesuré: {x.poidsMesure} / {x.numeroPalette} / {x.typePalette} / {x.poidsPalette} {x.anomalieExpedition ? ' - Anomalie : ' + anomalieExpeditionLabels[x.anomalieExpedition] : ''}

                                                        {x.dateExpedition && (
                                                            <>
                                                                <span> - Date d'expédition logistique : </span> 
                                                                <Datetime withTime datetime={x.dateExpedition} />
                                                            </>
                                                        )}

                                                        {!x.dateExpedition && !x.anomalieExpedition && (
                                                            <span> - Pas de date d'expédition logistique.</span>
                                                        )}

                                                    </Typography>

                                                    {x.photoId && (
                                                        <ColisLogistiquePhoto
                                                            colis={x}
                                                            label={`Colis ${index + 1} : ${x.numeroTracking}`}
                                                        />
                                                    )}

                                                </AccordionSummary>
                                                <AccordionDetails className={classes.expandDetails} classes={{ root: classes.expandDetailsRoot }}>
                                                    <Typography variant="caption">Colis {index + 1} : {x.numeroTracking} / {x.numeroSSCC} / {x.numeroSupport}{x.recepisse !== null ? ' / ' + x.recepisse : ''}</Typography>

                                                    <div className={classes.expandDetailsArticles}>
                                                        {x.lignes.map((l, i) => (
                                                            <Typography className={l.anomalie ? classes.anomalie : null} key={i}>{l.codeArticle} / {l.designationArticle} / {l.quantite}</Typography>
                                                        ))}
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </Paper>
                                )}

                                {infosLogistique.articles && (
                                    <Paper className={classes.listeColis} elevation={1}>
                                        <Typography variant="subtitle1" gutterBottom>Liste des articles</Typography>

                                        {infosLogistique.articles.map((x, index) => (
                                            <Accordion elevation={1} key={index}>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <Typography key={index} className={x.anomalie ? classes.anomalieExpandHeader : classes.expandHeader}>Article {x.description.codeArticle} / {x.description.designationArticle}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails className={classes.expandDetails} classes={{ root: classes.expandDetailsRoot }}>
                                                    <Typography variant="body2">Description</Typography>
                                                    <Typography>Prix {x.description.prixRevient ? 'de revient' : x.description.prixAchat ? 'd\'achat' : ''} : {x.description.prixRevient ? x.description.prixRevient : x.description.prixAchat}</Typography>
                                                    <Typography>Nom du fournisseur: {x.description.nomFournisseur}</Typography>
                                                    <Typography>{x.description.catalogue}</Typography>
                                                    <Typography>Poids unitaire: {x.description.poidsUnitaire}</Typography>
                                                    <Typography>Référence fournisseur: {x.description.referenceFournisseur}</Typography>
                                                    <Typography>Commentaire préparation: {x.description.commentairePrepa}</Typography>
                                                    <Typography variant="body2">Préparations</Typography>
                                                    {x.preparations.map((p, i) => (
                                                        <div key={`emp${i}`}>
                                                            {p.emplacementPicking &&
                                                                <Typography>Emplacement picking : {p.emplacementPicking} / Support : {p.supportPreparation} / Type support: {p.typeSupport} / Preparateur: {p.preparateur} / Qté demandée: {p.quantiteDemandee} / Qté préparée: {p.quantitePreparee}</Typography>
                                                            }
                                                            {!p.emplacementPicking &&
                                                                <Typography>Preparateur: {p.preparateur}</Typography>
                                                            }
                                                        </div>
                                                    ))}
                                                    <Typography variant="body2">Stocks actuels</Typography>
                                                    {x.stock.map((s, st) => (
                                                        <div key={`stock${st}`}>
                                                            <Typography>Entrepot : {s.entrepot} / Magasin: {s.magasin} / Emplacement: {s.emplacement} / Quantite: {s.quantite}</Typography>
                                                        </div>
                                                    ))}
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </Paper>
                                )}
                            </Paper>
                        )
                    }
                </>
                }
            </React.Fragment >
        );
    }
}

export default withStyles(styles)(InfosLogistique);